import { render, staticRenderFns } from "./manage-approved-trainings.vue?vue&type=template&id=21255708&"
import script from "./manage-approved-trainings.vue?vue&type=script&lang=js&"
export * from "./manage-approved-trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports